import React from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex min-h-screen flex-col bg-white" data-id="element-132">
      <Navigation data-id="element-133" />
      <main className="flex-grow" data-id="element-134">{children}</main>
      <Footer data-id="element-135" />
    </div>;
}